import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTextLanguage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.2 4.73077C8.0886 4.44112 7.81032 4.25 7.49999 4.25C7.18966 4.25 6.91138 4.44112 6.79998 4.73077L1.79998 17.7308C1.65129 18.1174 1.84415 18.5513 2.23075 18.7C2.61736 18.8487 3.0513 18.6558 3.2 18.2692L4.36124 15.25H10.6387L11.8 18.2692C11.9487 18.6558 12.3826 18.8487 12.7692 18.7C13.1558 18.5513 13.3487 18.1174 13.2 17.7308L8.2 4.73077ZM10.0618 13.75L7.49999 7.08926L4.93816 13.75H10.0618Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.25 11.9997C19.6233 11.529 18.8442 11.25 18 11.25C15.9289 11.25 14.25 12.9289 14.25 15C14.25 17.0711 15.9289 18.75 18 18.75C18.8442 18.75 19.6233 18.471 20.25 18.0003C20.2501 18.4144 20.5859 18.75 21 18.75C21.4142 18.75 21.75 18.4142 21.75 18V12C21.75 11.5858 21.4142 11.25 21 11.25C20.5859 11.25 20.2501 11.5856 20.25 11.9997ZM18 12.75C16.7574 12.75 15.75 13.7574 15.75 15C15.75 16.2426 16.7574 17.25 18 17.25C19.2426 17.25 20.25 16.2426 20.25 15C20.25 13.7574 19.2426 12.75 18 12.75Z",
		fill: "currentColor"
	})]
});
export { SvgIconTextLanguage as ReactComponent };
